import axios from 'axios';

// Determine the base URL based on environment
const getBaseUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    // In production, use relative path since FE and BE are served from same origin
    return '/api';
  }
  // In development, use the full URL
  return 'http://localhost:3000/api';
};

// Create the axios instance
const api = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
});

// Add a response interceptor to handle expired tokens (401 errors)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login if we're not already on login or verify pages
    if (error.response && error.response.status === 401) {
      const currentPath = window.location.pathname;
      const authPaths = ['/login', '/verify'];
      
      // Only redirect if we're not already on an auth page
      if (!authPaths.some(path => currentPath.startsWith(path))) {
        console.log('Auth error detected, redirecting to login');
        window.location.href = '/login';
      } else {
        console.log('Auth error on auth page, not redirecting');
      }
    }
    return Promise.reject(error);
  }
);

export default api;
